import { render, staticRenderFns } from "./editArticleNew.vue?vue&type=template&id=7b199916&scoped=true&"
import script from "./editArticleNew.vue?vue&type=script&lang=js&"
export * from "./editArticleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b199916",
  null
  
)

export default component.exports